import { FuelButton, FuelGridContainer, FuelGridItem, FuelTypography } from '@frete.com/fuel-react'
import { Props } from './interfaces'
import * as Styled from './styled'
import { useNavigate } from 'react-router-dom'
import { ModalAside } from '~components'
import { AmplitudeEvent } from '~constants/amplitude'
import { Text } from '~constants/text'
import { useAmplitude, useGlobals, useTranslator } from '~hooks'
import { ReactElement } from 'react'

const Success = ({
  open,
  onClose,
  label = Text.WE_RECEIVED_YOUR_REQUEST,
  content = Text.COMERCIAL_TEAM_CONTACT,
}: Props): ReactElement => {
  const navigate = useNavigate()
  const { userData } = useGlobals()
  const { sendAmplitude } = useAmplitude()
  const { translate } = useTranslator()

  function handleClose() {
    onClose?.(navigate)
    sendAmplitude('user_plan_button_requested_plan', {
      company_id: userData?.company.id,
      user_id: userData?.id,
      type: 'clique-fechar-modal-planos',
    })
  }

  function handleBackPage() {
    onClose?.(navigate)
    sendAmplitude(AmplitudeEvent.USER_PLAN_BUTTON_REQUESTED_PLAN, {
      company_id: userData?.company.id,
      user_id: userData?.id,
      type: 'clique-ok-plano-requisitado',
    })
  }

  return (
    <ModalAside open={open} portalName="user-plans-success" closeIcon="close" onClose={handleClose}>
      <Styled.Container>
        <FuelGridContainer style={{ margin: 0 }} gapRow={16}>
          <FuelGridItem>
            <Styled.CustomerSupportSvg />
          </FuelGridItem>
          <FuelGridItem>
            <FuelTypography tag="h1" variant="bold" size="heading-lg">
              {translate(label)}
            </FuelTypography>
          </FuelGridItem>
          <FuelGridItem>
            <FuelTypography tag="p" color="neutral-default" size="body-lg">
              {translate(content)}
            </FuelTypography>
          </FuelGridItem>
          <FuelGridItem>
            <FuelButton onClick={handleBackPage} data-testid="success-button">
              {translate(Text.OK_GOT_IT)}
            </FuelButton>
          </FuelGridItem>
        </FuelGridContainer>
      </Styled.Container>
    </ModalAside>
  )
}

Success.defaultProps = {
  open: false,
}

export default Success
